import React from "react";

import { Button } from "aible";

import styles from "./style.module.css";

const MarketSidebar = (props) => {
  const { type, buttonOnClick } = props;

  const sidebarTexts = [
    {
      type: "find blueprints",
      buttonText: "Sell Your Blueprint",
      titleText: "Search Available Blueprints"
    },
    {
      type: "job postings",
      buttonText: "Post a New Job",
      titleText: "Search Jobs"
    },
    {
      type: "find data",
      buttonText: "Sell Your Data",
      titleText: "Search Available Dataset"
    }
  ];

  const currentText = sidebarTexts.find((text) => text.type === type);
  const specialities = [
    "Data Transformation",
    "Data Exploration",
    "Blueprint Creation",
    "AI Creation",
    "AI Deployment"
  ];

  const experienceLevels = ["1-5 Projects", "6-10 Projects", "11+ Projects"];

  const generateCheckboxes = (data) => {
    return data.map((speciality) => (
      <div className={styles.checkboxSection} key={speciality}>
        <input style={{ margin: "0px" }} type="checkbox" />
        <div style={{ marginLeft: "10px" }}>{speciality}</div>
      </div>
    ));
  };
  return (
    <div className={styles.sidebarContainer}>
      <div className={styles.sidebarSection}>
        <Button
          type="primary"
          onClick={() => {
            if (buttonOnClick) {
              buttonOnClick(true);
            }
          }}
        >
          {currentText.buttonText}
        </Button>
      </div>
      <div className={styles.sidebarSection} style={{ fontWeight: "bold", fontSize: "16px" }}>
        {currentText.titleText}
      </div>
      <div className={styles.sidebarSection}>
        <div className={styles.sidebarSectionTitle}>Keyword Search</div>
        <input placeholder="Search Keywords" />
      </div>
      {type === "hire consultants" && (
        <div className={styles.sidebarSection}>
          <div className={styles.sidebarSectionTitle}>Location</div>
          <input placeholder="Add a location" />
        </div>
      )}
      {(type === "find blueprints" || type === "find data") && (
        <div className={styles.sidebarSection}>
          <div className={styles.sidebarSectionTitle}>Industry</div>
          <input placeholder="Select an Industry" />
        </div>
      )}
      {(type === "hire consultants" || type === "job postings") && (
        <div className={styles.sidebarSection}>
          <div className={styles.sidebarSectionTitle}>Job Type</div>
          {generateCheckboxes(specialities)}
        </div>
      )}
      {(type === "hire consultants" || type === "job postings") && (
        <div className={styles.sidebarSection}>
          <div className={styles.sidebarSectionTitle}>Experience Level</div>
          {generateCheckboxes(experienceLevels)}
        </div>
      )}
      <div className={styles.sidebarSection}>
        <div className={styles.sidebarSectionTitle}>Price Range</div>
        <div className={styles.rangeInputs}>
          <input style={{ marginRight: "5px", width: "50%" }} placeholder="Min" />
          <input style={{ width: "50%" }} placeholder="Max" />
        </div>
      </div>
    </div>
  );
};

export default MarketSidebar;
